<template>
  <v-card color="white" flat>
    <v-card-text>
      <v-layout wrap row class="pa-2 pt-0 mt-1" v-if="currentItem">
      <v-flex xs12 class="pa-2 bordernone pt-0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-text-field
              color="white"
              class="textblock pt-4 px-3 mt-0"
              clearable
              v-model="currentItem.name"
              label="Dokument Name"
              @change="onChangeName"
              v-on="on"
            ></v-text-field>
          </template>
          <span>{{currentItem.completeFileName}}</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12 class="pa-2 bordernone">
        <v-layout>
          <v-flex xs9>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              locale="de-DE"
              transition="scale-transition"
              offset-y
              full-width
              min-width="400px"
              :return-value.sync="date"
              ref="menu"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  color="#6f6f6e"
                  class="my-input textblock pt-4 px-3"
                  label="Datum"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker width="400" class="datebackground" color="#6274af" no-title locale="de-DE" @change="onChangeDate" v-model="datePS" scrollable>
                <v-btn flat color="grey" @click="menu = false" class="text-none">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn flat color="grey" @click="$refs.menu.save(date)" class="text-none">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="#5f6da9" v-on="on" icon @click="getEntities" flat large class="mt-3">
                  <v-icon large>batch_prediction</v-icon>
                </v-btn>
              </template>
              <span>Finde das Datum</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="pa-2 mt-3">
        <v-layout>
          <v-flex xs9>
            <v-select
              v-model="currentItem.listCategories"
              :items="categories"
              label="Kategorien"
              item-text="title"
              v-if="categories!=null"
              item-value="guid"
              @change="onChangeItemCategory"
              clearable
              multiple
              chips
              solo
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  label
                  outline
                  color="#5f6da9"
                  @input="removeCategory(data.item)"
                >
                  <strong>{{ data.item.title }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs3>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="#5f6da9" v-on="on" icon @click="updateValuesAutomatically" flat large class="mt-3">
                  <v-icon large>batch_prediction</v-icon>
                </v-btn>
              </template>
              <span>Finde Kategorien</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="pa-2 bordernone">
        <v-combobox
          v-model="currentStatus"
          :items="statusList"
          label="Status"
          item-text="title"
          return-object
          v-if="catStatusByGuid!=null"
          class="pr-2 pt-0 textblock pt-4 px-3"
          @change="onChangeStatus"
          clearable
        >
        </v-combobox>
      </v-flex>
      <v-flex xs12 class="pa-2 pt-0 justify-start bordernone" :key="extraFieldsKey">
        <v-layout row wrap v-for="(category, i) in currentItem.listCategories" v-bind:key="i" class="justify-start px-2">
          <v-flex xs12 v-for="field in getExtraFields(category)" class="pa-2" v-bind:key="field.id">
            <v-text-field :prefix='field.labelValue' v-if="field.typ === 'Currency'"
                          v-model="currentItem.extraFields[category.internal_id + '_' + field.key]"
                          :label="field.name + ' (' + category.title+')'" class="textblock pt-4 px-3"></v-text-field>
            <v-text-field :prefix='field.labelValue' v-else
                          v-model="currentItem.extraFields[category.internal_id + '_' + field.key]"
                          :label="field.name + ' (' + category.title+')'" class="textblock pt-4 px-3"></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
        <v-card-actions>
          <v-btn outline dark color="#405606" v-if="!isNewFile" @click="saveFile()" class="text-none my-3">
            {{'BTN_SAVE' | translate}}
            <!--<v-icon right dark>storage</v-icon>-->
          </v-btn>
        </v-card-actions>
      <!--
        <v-card-actions>
        <v-layout row wrap justify-center>
          <v-flex md11>
            <v-btn dark block outline round color="primary" v-if="!isNewFile" @click="downloadFile()" class="text-none">Herunterladen
              <v-icon right dark>cloud_download</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
      <v-card-actions>
        <v-layout row wrap justify-center>
          <v-flex md11>
            <v-btn block outline round dark color="red" v-if="!isNewFile" @click="showDeleteDialog" class="text-none mt-3">Dokument löschen</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
      -->
    </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import sas from 'surfandscan'
var _ = require('lodash')
export default {
  name: 'TabDetail',
  props: [],
  data () {
    return {
      pdfStyle: 'overflow: auto',
      url: null,
      documentError: null,
      taskId: null,
      pageOrder: null,
      categories: null,
      rotateArr: null,
      currentPageNumber: 1,
      currentPage: null,
      pdf: null,
      renderTask: null,
      pageCnt: 0,
      isNewFile: false,
      delDialog: false,
      menu: false,
      date: '',
      jobs: [],
      dateObj: new Date(),
      datePS: '',
      dialog: false,
      catStatusByGuid: [],
      statusList: [],
      currentItem: null,
      isLoading: false,
      currentStatus: null,
      extraFieldsKey: 0
    }
  },
  methods: {
    onChangeStatus (f) {
      console.log('onChangeStatus', f)
      this.saveItem()
    },
    onChangeItemCategory: function (item) {
      console.log('onChangeItemCategory', item)
      this.saveItem()
    },
    removeCategory: function (item) {
      var index = this.currentItem.listCategories.indexOf(item)
      if (index > -1) {
        this.currentItem.listCategories.splice(index, 1)
      }
      this.saveItem()
    },
    updateValuesAutomatically () {
      this.currentItem.listCategories = []
      for (var i in this.categories) {
        var cat = this.categories[i]
        if (cat.categorySelectWord && cat.categorySelectWord.length > 0 && this.currentItem.rawText) {
          let index = this.currentItem.rawText.toLowerCase().indexOf(cat.categorySelectWord.toLowerCase())
          if (index > -1) {
            this.currentItem.listCategories.push(cat)
          }
        }
      }
      this.extraFieldsKey++
    },
    getExtraFields: function (cat) {
      let category = Vue.prototype.$storage.getCategoriesObjectGuidList()[cat.guid]
      let fieldArray = []
      if (!category) return fieldArray
      if (!category.extraFields) return fieldArray
      for (const [key, value] of Object.entries(category.extraFields)) {
        if (key) {
          fieldArray.push(value)
        }
      }
      return fieldArray
    },
    onChangeName: function () {
      console.log('onChangeName')
      this.saveItem()
    },
    open: function (currentItem) {
      this.currentItem = currentItem
      this.updateTimeInGui(this.currentItem.targetDate)
      this.categories = Vue.prototype.$storage.getCategories()
      this.catNames = Vue.prototype.$storage.getCategoriesNamesList()
      this.catObjectsByGuid = Vue.prototype.$storage.getCategoriesObjectGuidList()
      this.catStatusByGuid = Vue.prototype.$storage.getStatusObjectGuidList()
      this.statusList = Vue.prototype.$storage.getStatusList()
      this.currentItem = this.prepareItem(this.currentItem)
    },
    saveItem: function () {
      console.log('saveItem', this.currentItem, this.currentItem.targetDate, new Date(this.currentItem.targetDate).getTime())
      // this.currentItem.categories.splice(0, this.currentItem.categories.length)
      var newCategories = []
      this.currentItem.categories.splice(0, this.currentItem.categories.length)
      for (var i in this.currentItem.listCategories) {
        var item = this.currentItem.listCategories[i]
        console.log('cat', item)
        if (item instanceof Object) {
          newCategories.push(item.guid)
        } else {
          newCategories.push(item)
        }

        this.currentItem.categories.push(item)
      }
      // this.currentItem.listCategories.splice(0, this.currentItem.listCategories.length)
      let dataObject = {
        name: this.currentItem.name,
        time: this.dateObj.getTime(),
        categories: newCategories.join(),
        status: null
      }
      if (this.currentStatus) {
        dataObject.status = [this.currentStatus.guid].join()
      }
      // sas.updateStorageItem(this.currentItem.guid, this.dateObj.getTime(), this.currentItem.name, newCategories, this.onUpdateDone)
      console.log('saveItem', dataObject, this.currentItem)
      Vue.prototype.$dms.updateStorageFile(this.currentItem.guid, dataObject, this.onUpdateDone)
    },
    prepareItem (item) {
      var selectedItem = item
      selectedItem.listCategories = []
      selectedItem.targetDate = new Date(selectedItem.time).toISOString().substr(0, 10)
      for (var i in item.categories) {
        var catGuid = item.categories[i]
        selectedItem.listCategories.push(this.catObjectsByGuid[catGuid])
      }
      selectedItem = Vue.prototype.$storage.checkExtraFieldStatus(selectedItem)
      // update Status
      this.currentStatus = null
      if (this.currentItem && this.currentItem.status) {
        let index = _.findIndex(this.statusList, ['guid', this.currentItem.status[0]])
        if (index > -1) {
          this.currentStatus = this.statusList[index]
        }
      }

      return selectedItem
    },
    updateTimeInGui (myTime) {
      var d = new Date(myTime)
      this.dateObj = d
      console.log('myTime', myTime, d)
      this.datePS = this.dateObj.toISOString().substr(0, 10)
      this.date = d.toLocaleDateString('de-DE')
    },
    saveFile: function () {
      console.log('save extraFields', this.currentItem)
      Vue.prototype.$dms.updateStorageItemExtraFields(this.currentItem.guid, JSON.stringify(this.currentItem.extraFields), this.onExtraFieldsUpdated)
    },
    getEntities: function () {
      Vue.prototype.$dms.getEntitiesFromStorageItem(this.currentItem.guid, this.onGetEntites)
    },
    onGetEntites: function (res) {
      let firstDate = true
      if (res && res.content) {
        if (res.content.entities && res.content.entities.length > 0) {
          for (let i in res.content.entities) {
            let entity = res.content.entities[i]
            if (firstDate && entity.type === 'date') {
              try {
                let d = moment(entity.value, 'DD.MM.YYYY')
                let f = d.format('YYYY-MM-DD')
                this.onChangeDate(f)
                firstDate = false
              } catch (e) {

              }
            }
          }
        }
      }
    },
    onExtraFieldsUpdated: function (res) {
      console.log('onExtraFieldsUpdated', res, this.currentItem)
      let cmp = this
      this.$emit('onSave', {
        item: cmp.currentItem
      })
      Vue.prototype.$eventHub.$emit('filespoolchanged')
      this.closeDialog()
    },
    printFile: function () {
      var blobUrl = sas.gbl_host + '/storage/item?method=PRINT&type=files&guid=' + this.currentItem.guid
      if (this.isNewFile) {
        blobUrl = sas.getDownloadTaskAsPDFURL(this.taskId, '', this.pageOrder, this.rotateArr)
      }
      console.log('print file', blobUrl)

      this.printTriggerfunction(blobUrl)
      /*
      var divToPrint = document.getElementById("printTable")
      let newWin = window.open('')
      const embed = document.createElement('embed')
      embed.type= 'application/pdf'
      embed.src = blobUrl
      embed.id = 'pdf'
      // newWin.document.write(divToPrint.outerHTML)
      newWin.document.body.appendChild(embed)
      window.setTimeout(function () {
        newWin.print()
        newWin.close()
      }, 4000)
       */
    },
    onChangeDate (date) {
      console.log('onChangeDate', date)
      const [year, month, day] = date.split('-')
      var d = new Date()
      d.setFullYear(year)
      d.setMonth(month - 1)
      d.setDate(day)
      d.setMinutes(0)
      d.setHours(12)
      d.setSeconds(0)
      console.log('onChangeDate', d, day)
      this.dateObj = d
      this.datePS = this.dateObj.toISOString().substr(0, 10)
      this.date = this.dateObj.toLocaleDateString('de-DE')
      this.currentItem.time = d.getTime()
      this.saveItem()
    },
    printTriggerfunction: function (url) {
      console.log('printTriggerfunction', url)
      var iframe = this._printIframe
      if (!this._printIframe) {
        iframe = this._printIframe = document.createElement('iframe')
        document.body.appendChild(iframe)
        iframe.src = url
        // iframe.style.display = 'none';
        iframe.onload = function () {
          setTimeout(function () {
            iframe.focus()
            iframe.contentWindow.print()
          }, 1)
        }
      }
      iframe.src = url
    },
    doPrinting: function (id) {
      var that = this
      var pId = id
      var pdfObject = document.getElementById(id)
      if (typeof (pdfObject.print) === 'undefined') {
        setTimeout(function () {
          that.doPrinting(pId)
        }, 1000)
      } else {
        pdfObject.print()
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/tabs/TabDetail.vue